export default [
    {
        path: '/catalogues/:formation_dda?',
        name: 'catalogues-list',
        component: () => import('@/views/catalogues/Lists.vue'),
    },
    {
        path: '/catalogues/{id}',
        name: 'catalogues-details',
        component: () => import('@/views/catalogues/Details.vue'),
    },
    // {
    //     path: '/catalogues/formation-dda',
    //     name: 'catalogues-formation-dda',
    //     component: () => import('@/views/catalogues/formation_dda/FormationDda.vue'),
    // }
]